import { Component, Input, Output, EventEmitter } from '@angular/core';

import { CarrierPerformanceService } from './carrier-performance.service';
import { Carrier, Trips, Trip } from './../../models';
import { Status } from './../../enums/status';
import { CarrierPerformanceSort } from '../../enums/sort';


@Component({
  selector: 'carrier-performance',
  template: require('./carrier-performance.component.html'),
  styles: [require('./carrier-performance.component.scss')],
  providers: [CarrierPerformanceService]
})
export class CarrierPerformanceComponent {
  public Status = Status;
  public Sort = CarrierPerformanceSort;

  public sortOrder = CarrierPerformanceSort.Time;
  public descending: boolean = true;
  public carriers: Array<Carrier>;
  private params: any;

  // popup
  public tripToDisplay: Trip;
  public showTrip: boolean = false;

  @Output() onShare: EventEmitter<any> = new EventEmitter();
  @Output() onContact: EventEmitter<Trip> = new EventEmitter();

  constructor(private service: CarrierPerformanceService) {
  }

  @Input()
  set items(carriers: Array<Carrier>) {
    let selected = new Array<Carrier>();
    for (let index = 0; index < carriers.length; index++) {
      if (carriers[index].selected) {
        selected.push(carriers[index]);
      }
    }

    selected.sort(this.sortItems.bind(this));

    this.carriers = selected;
  }

  @Input()
  set parameters(params: any) {
    this.params = params;
  }

  share(): void {
    this.onShare.emit();
  }

  contact(trip: Trip): void {
    this.onContact.emit(trip);
  }

  setSort(orderToSet: CarrierPerformanceSort): void {
    if (orderToSet !== this.sortOrder) {
      this.descending = true;
    } else {
      this.descending = !this.descending;
    }
    this.sortOrder = orderToSet;

    this.carriers.sort(this.sortItems.bind(this));
  }

  sortItems(a: Carrier, b: Carrier): number {
    switch (this.sortOrder) {
      case CarrierPerformanceSort.Carrier:
        return this.sortByCarrier(a, b);
      case CarrierPerformanceSort.Count:
        return this.sortByCount(a, b);
      case CarrierPerformanceSort.Time:
        return this.sortByTime(a, b);
      case CarrierPerformanceSort.Tranships:
        return this.sortByTranships(a, b);
      default:
        return this.sortByTranships(a, b);
    }
  }

  sortByTranships(a: Carrier, b: Carrier): number {
    let one = a.minTranshipments;
    let two = b.minTranshipments;
    let sorted = (one < two) ? -1 : (one > two) ? 1 : 0;

    if (sorted === 0) {
      sorted = (a.minDuration < b.minDuration) ? -1 : (a.minDuration > b.minDuration) ? 1 : 0;
    }

    return this.descending ? sorted : -1 * sorted;
  }

  sortByCarrier(a: Carrier, b: Carrier): number {
    let one = a.name.toUpperCase();
    let two = b.name.toUpperCase();
    let sorted = (one < two) ? -1 : (one > two) ? 1 : 0;

    return this.descending ? sorted : -1 * sorted;
  }

  sortByTime(a: Carrier, b: Carrier): number {
    let one = a.minDuration;
    let two = b.minDuration;
    let sorted = (one < two) ? -1 : (one > two) ? 1 : 0;

    if (sorted === 0) {
      sorted = (a.minTranshipments < b.minTranshipments) ? -1 : (a.minTranshipments > b.minTranshipments) ? 1 : 0;
    }

    return this.descending ? sorted : -1 * sorted;
  }

  sortByCount(a: Carrier, b: Carrier): number {
    let one = a.count;
    let two = b.count;
    let sorted = (one < two) ? -1 : (one > two) ? 1 : 0;

    if (sorted === 0) {
      sorted = (a.minDuration < b.minDuration) ? -1 : (a.minDuration > b.minDuration) ? 1 : 0;
    }

    return this.descending ? sorted : -1 * sorted;
  }

  viewDetails(carrier: Carrier): void {
    if (carrier.trips == null) {
      carrier.status = Status.Loading;
      this.service.getSchedules(carrier, this.params).then((schedules: Trips) => {
        carrier.setTrips(schedules.items);
        carrier.status = Status.Loaded;
      }).catch(err => {
        carrier.status = Status.Error;
      });
    }
    carrier.viewDetails = !carrier.viewDetails;
  }

  displayTrip(trip: Trip): void {
    this.tripToDisplay = trip;

    this.showTrip = true;
  }

  closeTrip(): void {
    this.showTrip = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/components/carrier-performance/carrier-performance.component.ts